import { render, staticRenderFns } from "./expend.vue?vue&type=template&id=3a6d0754&scoped=true&"
import script from "./expend.vue?vue&type=script&lang=js&"
export * from "./expend.vue?vue&type=script&lang=js&"
import style0 from "./expend.vue?vue&type=style&index=0&id=3a6d0754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d0754",
  null
  
)

export default component.exports